export const FETCH_ASSETS_START = "FETCH_ASSETS_START";
export const FETCH_ASSETS_SUCCESS = "FETCH_ASSETS_SUCCESS";